<template>
  <transition name="loader-fade">
    <div class="loader-overlay" v-if="isActiveStatus">
      <div class="loader-box">
        <div class="loader-ring">
          <div></div><div></div><div></div><div></div>
        </div>
        <div class="loader-text">Loading&hellip;</div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Loader",
  props: {
    isActiveStatus: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="css" scoped>
.loader-overlay {
  position: fixed;
  inset: 0;
  z-index: var(--z-loader, 60);
  background: var(--bg-overlay, rgba(15, 23, 42, 0.55));
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.loader-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

/* Ring spinner */
.loader-ring {
  display: inline-block;
  position: relative;
  width: 52px;
  height: 52px;
}

.loader-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 44px;
  height: 44px;
  margin: 4px;
  border: 4px solid transparent;
  border-radius: 50%;
  animation: ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.loader-ring div:nth-child(1) { border-top-color: var(--brand-orange, #f97316); animation-delay: -0.45s; }
.loader-ring div:nth-child(2) { border-top-color: rgba(var(--brand-rgb, 249, 115, 22), 0.6); animation-delay: -0.3s; }
.loader-ring div:nth-child(3) { border-top-color: rgba(var(--brand-rgb, 249, 115, 22), 0.3); animation-delay: -0.15s; }
.loader-ring div:nth-child(4) { border-top-color: rgba(var(--brand-rgb, 249, 115, 22), 0.1); }

@keyframes ring {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loader-text {
  color: var(--text-inverse, #ffffff);
  font-size: 0.8rem;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  opacity: 0.8;
}

.loader-fade-enter-active, .loader-fade-leave-active {
  transition: opacity 0.2s ease;
}
.loader-fade-enter-from, .loader-fade-leave-to {
  opacity: 0;
}
</style>
